import { ColumnFilterOrDisplayType, ConfigColumns2 } from "../../types/configColumns2";
import { momentDtoToLocalStringByCulture } from "../../aplUtils/dateHelper";
import { MovementView } from "../../types/movementView";
import { Culture } from "../../types/culture";
import { renderMovementType, renderPalletCondition, renderPalletStatus } from "../../aplUtils/statusConditionEnumHelper";
import { DefectType } from "../../types/defectType";
import { translateString } from "../../translations/gridTranslationHelper";

const palstatEditMovementsColumnData = (siteId: number, culture: Culture, defectTypes: DefectType[]): ConfigColumns2[] => {
    return [
        {
            data: "mvtDate",
            className: "nowrap",
            render: function (data: MovementView, type: ColumnFilterOrDisplayType | undefined) {
                if (!data) return "";
                return type === "sort" ? data.mvtDate : momentDtoToLocalStringByCulture(data.mvtDate, culture);
            },
            width: "80px",
            title: "mvtDate",
        },
        {
            data: "movementsType",
            className: "",
            width: "33%",
            title: "mvtDesc",
            render: function (data: MovementView, type: ColumnFilterOrDisplayType | undefined) {
                let movementDesc = renderMovementType(data.movementsType, culture);
                let defect = defectTypes.find(x => x.defectId === data.defectId);
                let defectName = data.defectId == null || data.defectId === 0 ? "" : defect?.defectName ?? `DefectId-${data.defectId}`;
                let mouldName =
                    data.mouldNumber == null || data.mouldNumber === 0 ? "" : `${translateString("mouldNo", culture)}-${data.mouldNumber}`;
                let comment = data.notes == null || data.notes === "" ? "" : data.notes;
                return (
                    <span>
                        {`${movementDesc}`}
                        {defectName === "" && mouldName === "" ? "" : <br />}
                        {`${defectName} ${mouldName}`}
                        {comment === "" ? "" : <br />}
                        {`${comment}`}
                    </span>
                );
            }
        },
        { data: "quantity", className: "", width: "10%", title: "quantity" },
        {
            data: "conditionName",
            className: "",
            width: "33%",
            title: "condition",
            render: function (data: MovementView, type: ColumnFilterOrDisplayType | undefined) {
                if (data.conditionFrom === data.conditionTo) {
                    return renderPalletCondition(data.conditionFrom, culture);
                } else {
                    let conditionA = renderPalletCondition(data.conditionFrom, culture);
                    let conditionB = renderPalletCondition(data.conditionTo, culture);
                    return `${conditionA} -> ${conditionB}`;
                }
            }
        },
        {
            data: "statusName",
            className: "",
            width: "33%",
            title: "status",
            render: function (data: MovementView, type: ColumnFilterOrDisplayType | undefined) {
                if (data.statusFrom === data.statusTo) {
                    return renderPalletStatus(data.statusFrom, culture);
                } else {
                    let statusA = renderPalletStatus(data.statusFrom, culture);
                    let statusB = renderPalletStatus(data.statusTo, culture);
                    return `${statusA} -> ${statusB}`;
                }
            }
        },
        { data: "userName", className: "", width: "33%", title: "username" }
    ];
};

const palstatEditMovementsOrderData = (siteId: number, culture: string) => {
    return [[0, "desc"]];
};

export { palstatEditMovementsColumnData, palstatEditMovementsOrderData };
